import RoleAssignmentDialog from './RoleAssignmentDialog';

export default RoleAssignmentDialog;
